import React from 'react';

export type SvgLockersSolidProps = React.SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

export const SvgLockersSolid = ({
  color = '#706E6E',
  size = 18,
  ...props
}: SvgLockersSolidProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.28571 4C3.57563 4 3 4.59695 3 5.33333V18.6667C3 19.403 3.57563 20 4.28571 20H8.14286V16H5.89286C5.71534 16 5.57143 15.8508 5.57143 15.6667V13.6667C5.57143 13.4826 5.71534 13.3333 5.89286 13.3333H8.14286V4H4.28571ZM9.42857 4V20H14.5714V16H12.3214C12.1439 16 12 15.8508 12 15.6667V13.6667C12 13.4826 12.1439 13.3333 12.3214 13.3333H14.5714V4H9.42857ZM15.8571 4V20H19.7143C20.4244 20 21 19.403 21 18.6667V16H18.75C18.5725 16 18.4286 15.8508 18.4286 15.6667V13.6667C18.4286 13.4826 18.5725 13.3333 18.75 13.3333H21V5.33333C21 4.59695 20.4244 4 19.7143 4H15.8571Z"
      fill={color}
    />
  </svg>
);
